export const PROGRESS_TEXT_COLORS = {
  dark: { primary: "#e2e1f4", secondary: "#b0b0c0" },
  light: { primary: "#0f172a", secondary: "#475569" },
};

export const getProgressTextColors = (mode) =>
  PROGRESS_TEXT_COLORS[mode] || PROGRESS_TEXT_COLORS.dark;
